import c from '../common';

export default {

  //Column
  "status": c.status.chn,
  "available": "可用",
  "AccUnopened": "尚未開户",
  "disabled": "已禁用",

  "type": "種類",
  "general_assistant": c.general_assistant.chn,
  "takeaway_assistant": c.takeaway_assistant.chn,

  "phone": c.phone.chn,
  "name": c.name.chn,
  "email": c.email.chn,
  "description": c.description.chn,


  //New Staff Pop-up
  "enterPhone": "請輸入員工資料",
  "cancel": c.cancel.chn,
  "add": c.add.chn,

  ///phone number
  "error1": "電話已被使用, 請重新輸入",
  "error2": "電郵已被使用, 請聯絡員工用 " + c.appName.chn + " 手機App開户",
  "error3": "電郵已被使用, 請重新輸入",
  "StaffPhoneNumber": "員工電話",
  "rule1": "請輸入電話",
  "rule2": "電話只可包含數字",
  "rule3": "不可含有空格",

  ///name
  "StaffName": "員工名稱",
  "enterName": "請輸入員工名稱",

  ///email
  "StaffEmail": "員工電郵",
  "enterEmail": "請輸入正確電郵",

  ///belongingshop
  "belongingVendor": "所屬商戶",


  //Title of the page
  "StaffMgtTitle": "員工管理",

  //Button to add new staff
  "addNewStaff": "新增員工",



  "description_1": "手機號碼無效",
  "description_2": "請聯絡員工, 打開手機App, 以 {{email}} 註冊開户",
  "description_3": "已註冊, 可使用手機App登入",
  "description_4": "已註冊, 可使用此網站登入",
  "description_5": c.general_assistant.chn,
  "description_6": "可售賣,換領所有e-Voucher, 優惠券",
  "description_7": c.takeaway_assistant.chn,
  "description_8": "只可查閱外賣單資料",
  "description_9": "下一步",
};